import React from "react";
import { Funnel, FunnelChart as RechartsFunnelChart, LabelList, ResponsiveContainer, Tooltip } from "recharts";
import styles from "../PartnerAnalyticsDashboard.module.css";

const FunnelChart = ({ items }) => {
  const palette = ["#3b82f6", "#1e40af", "#1e3a8a", "#0f172a"];
  const data = (items || []).map((item, index) => ({
    name: item.step,
    value: item.value,
    fill: palette[index % palette.length],
  }));

  return (
    <div className={styles.chartFrame}>
      <ResponsiveContainer width="100%" height={320}>
        <RechartsFunnelChart>
          <Tooltip
            formatter={(value) => [Number(value).toLocaleString("fr-FR"), "Volume"]}
            contentStyle={{
              borderRadius: 10,
              border: "none",
              boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
              background: "#ffffff",
              padding: "10px 12px",
            }}
            labelStyle={{ fontWeight: 800, color: "#0f172a" }}
          />
          <Funnel dataKey="value" data={data} isAnimationActive animationDuration={900}>
            <LabelList
              position="right"
              dataKey="name"
              fill="#0f172a"
              stroke="none"
              style={{ fontSize: 12, fontWeight: 800 }}
            />
          </Funnel>
        </RechartsFunnelChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FunnelChart;
